import _ from 'lodash';
import userRoleService from './userRoles.service';

export default class subscriptionPlanService {

  static initialise(account) {
    this.account = account;
    this.plan = _.get(this.account, 'subscription.subscriptionPlan', false);
  }

  static isInitialized() {
    return !!this.plan && !!this.account;
  }

  static canAccessHub() {
    return _.get(this.plan, 'hub.access', false);
  }

  static canCreateAsset() {
    return _.get(this.plan, 'hub.access', false) && _.get(this.plan, 'createAsset.access', false);
  }

  static canAccessContentMap() {
    return _.get(this.plan, 'hub.access', false) && _.get(this.plan, 'contentMap.access', false);
  }

  static canCloneHub() {
    return _.get(this.plan, 'hub.access', false) && _.get(this.plan, 'hub.customHub', 0) > 1;
  }

  static fetchCustomHubLimit() {
    return _.get(this.plan, 'hub.customHub', 0);
  }

  static canAccessCollection() {
    return _.get(this.plan, 'collection.access', false);
  }

  static canAccessDealRoom() {
    return _.get(this.plan, 'dealRoom.access', false);
  }

  static canColloborateCollection() {
    return _.get(this.plan, 'collection.access', false) && _.get(this.plan, 'collection.collaborate', false);
  }

  static canAccessReports() {
    return _.get(this.plan, 'report.access', false);
  }

  static canShare() {
    return _.get(this.plan, 'share.access', false);
  }

  static canAccessNativeEditor() {
    return _.get(this.plan, 'nativeEditor.access', false);
  }

  static getCollectionExperiences() {
    return _.get(this.plan, 'collection.viewerTypeList', []);
  }

  static getCollectionAssetViewers() {
    return _.get(this.plan, 'collection.assetViewerList', []);
  }

  static canAccessEngage() {
    return _.get(this.plan, 'engage.access', false);
}

static canAccessDealInsights() {
    return _.get(this.plan, 'dealInsights.access', false);
}

static getViewerTypeList() {
    var viewerTypes = _.get(this.plan, 'collection.viewerTypeList',[]);
   
    viewerTypes = viewerTypes.filter(viewerType => {
        return !(viewerType === 'DEAL_ROOM' && !userRoleService.canShare()); // If it's a deal room and user don't have access to share, removing it.
    });

    return viewerTypes;
}

static getAssetViewerList() {
    return _.get(this.plan, 'collection.assetViewerList', []);
}

static isLegacyPlan() {
    return _.get(this.plan, 'key', "") === 'legacy';
}
}